import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SharedModeService } from '../shared/services/shared-mode.service';
import { DashboardService } from '../shared/services/dashboardservices/dashboard.service';
import { AttendanceService } from '../shared/services/attendanceservices/attendance.service';
import * as moment from 'moment';
import { AgChartOptions } from 'ag-charts-community';
import { FormsModule, NgForm } from '@angular/forms';
import { AccountsservicesService } from '../shared/services/accountservices/accountsservices.service';
import Swal from 'sweetalert2';
import { CommonModule, Location } from '@angular/common';
import { ExportAsConfig, ExportAsService } from 'ngx-export-as';
import * as XLSX from 'xlsx-js-style';
import { LoaderComponent } from '../shared/components/loader/loader.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AgChartsAngularModule } from 'ag-charts-angular';
import { ModalModule } from 'ngx-bootstrap/modal';

declare let $: any;
@Component({
  selector: 'app-account-managment',
  templateUrl: './account-managment.component.html',
  styleUrl: './account-managment.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, ModalModule, NgApexchartsModule, AgChartsAngularModule]
  ,
  providers: [ExportAsService]
})
export class AccountManagmentComponent implements OnInit {
  @ViewChild('errorModal') errorModal!: ElementRef;
  @ViewChild('addexpense') addExpenseModal!: ElementRef;


  public showSpinner = true;
  user: any;
  id: any;
  userInfo: any;
  colormode: any;
  currentTab = 1;
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 100;
  graphdataArray: any = [];
  isExpanded = false;
  selectedMode: any;
  datamode: any;
  showHiddenDiv1 = false;
  typeArr: any = [];
  public overtime: any = '';
  public workingHours: any = '';
  public stats: any = [];
  public checkInStatus: any = '';
  public checkStats = false;
  public checkInTime: any = '';

  public leaves: any[] = [];
  public paidLeaves: any[] = [];
  public unpaidLeaves: any[] = [];
  public actionattendance: any[] = [];
  public startdate: any;
  public endDate: any;
  public filterType = "";
  public filterMonth = "";
  public topState: any[] = [];
  shiftRemainingTime = "00:00:00";
  percentageInProgress = 100;
  checkInArrayForGraph: any[] = [];
  checkOutArrayForGraph: any[] = [];
  checkInChartData: any = {};
  checkOutChartData: any = {};
  checkInData: any[] = [];
  checkOutData: any[] = [];
  isPrintPage = false;
  printingContent: any = {};
  checkInDays: any[] = [];
  checkOutDays: any[] = [];
  secondShitEmployees = [46, 55, 60, 63, 61, 73, 112];
  checkOutDate: any;
  totalHours = 0;
  checkOutTime = "";
  checkInDate: any;
  account_type: any;
  user_Amount: any[] = [];
  total_Amount: any;
  expense: any;
  reserve: any;
  deposit: any;
  accountData: any[] = [];
  originalData: any[] = [];
  showErrorModal = false;
  options: AgChartOptions = {
    series: [
      {
        data: this.graphdataArray,
        type: "pie",
        calloutLabelKey: "amount",
        sectorLabelKey: "gdppermonth",
        angleKey: "availibleamount",
        radiusKey: "gdppermonth",
      },
    ],

  };
  selectedOption = '';
  user_reserve: any[] = [];
  exportType = '';
  form_data: any;
  modalData: any;
  editeamount: any;
  editedate: any;
  editedescription: any;
  editeexpense_type: any;
  tab: any;
  startDate: any;
  start_Date: any;
  end_Date: any;
  filtedata: any;
  account_id: any;
  admin_id: any;
  apiData: any;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private sharedmode: SharedModeService,
    public dashboardService: DashboardService,
    private attendanceService: AttendanceService,
    private accountsServices: AccountsservicesService,
    private _location: Location,
    private exportAsService: ExportAsService


  ) {
    this.user = JSON.parse(localStorage.getItem('user') || ''),
      this.user_detail();
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.showSpinner = false;
    this.useramount();
    this.totalamount();
    this.chartvalue();
    this.getCategory();


    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  // date filter
  acountfilter() {
    const startDate = this.start_Date
    const endDate = this.end_Date
    this.accountsServices.getamountfilter(startDate, endDate).then((value) => {
      this.showSpinner = false;
      this.filtedata = value.data;
      // Export filtered data after fetching
      if (this.filtedata.length != 0) {
        this.exportDataToExcel(this.filtedata, 'Data According to date');
        window.location.reload()

      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: 'No data is Found',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
    });
  }

  exportData() {

    if (this.exportType === 'debit') {
      this.exportDebitData();
    } else if (this.exportType === 'credit') {
      this.exportCreditData();
    } else if (this.exportType === 'all_data') {
      this.exportAllData();
    } else {
      this.acountfilter();
    }

  }

  exportDebitData() {

    const debitData = this.user_Amount.filter(item => item.account_type === 'debit');
    if (!debitData || debitData.length === 0) {
      alert('No debit data available to export.');
    } else {
      const name = debitData[0].first_name

      this.exportDataToExcel(debitData, name);
      window.location.reload()

    }
  }

  exportCreditData() {

    const creditData = this.user_Amount.filter(item => item.account_type === 'credit');
    if (!creditData || creditData.length === 0) {
      alert('No credit data available to export.');
    } else {
      const name = creditData[0].first_name
      this.exportDataToExcel(creditData, name);
      window.location.reload()

    }
  }

  exportAllData() {
    const allData = this.user_Amount;
    const name = this.user_Amount[0].first_name
    const full_name = name
    this.exportDataToExcel(allData, full_name);
    // window.location.reload()

  }

  getCategory() {
    this.showSpinner = true;
    this.accountsServices.getcatdetail().then((value) => {
      this.apiData = value;
      this.showSpinner = false;
    })

  }



  exportDataToExcel(data: any[], filename: string) {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);

    const wscols = [
      { wch: 4 },
      { wch: 10 },
      { wch: 12 },
      { wch: 20 },
      { wch: 20 },
      { wch: 16 },
      { hidden: true },
      { hidden: true },
      { hidden: true },
      { wch: 17 },
      { wch: 16 },
      { wch: 16 },
      { wch: 13 },
      { wch: 13 }
    ];

    worksheet['!cols'] = wscols;
    const range = XLSX.utils.decode_range(worksheet['!ref'] as string);
    const noRows = range.e.r;

    const wsRows = [];
    for (let i = 0; i <= noRows; i++) {
      wsRows.push({ hpt: 25 });
    }
    worksheet['!rows'] = wsRows;
    const headerRowIndex = 0;
    const headerRowRange = XLSX.utils.decode_range(worksheet['!ref'] as string);

    for (let c = headerRowRange.s.c; c <= headerRowRange.e.c; c++) {
      const cellAddress = XLSX.utils.encode_cell({ r: headerRowIndex, c: c });

      worksheet[cellAddress].s = {
        font: { bold: true, color: { rgb: 'F79646' } },
        fill: { bgColor: { rgb: 'E9E9E9' } },
        border: {
          top: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
          left: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } }
        }
      };
    }

    for (let i = headerRowIndex + 1; i <= headerRowRange.e.r; i++) {
      for (let c = headerRowRange.s.c; c <= headerRowRange.e.c; c++) {
        const cellAddress = XLSX.utils.encode_cell({ r: i, c: c });

        worksheet[cellAddress].s = {
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } }
          }
        };
      }
    }

    let c = 1;

    // Apply formatting to all cells
    for (let i = 0; i < data.length; i++) {
      let x = i;
      x = x + 2;
      if (data[i]['account_type'] === 'credit') {
        worksheet['B' + x].s = {
          font: {
            name: 'Calibri',
            sz: 12,
            bold: true,
            color: { rgb: '00FF00' },
          },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } }
          }

        };

      }
      if (data[i]['account_type'] === 'debit') {
        worksheet['B' + x].s = {
          font: {
            name: 'Calibri',
            sz: 12,
            bold: true,
            color: { rgb: 'ff0000' },
          },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } }
          }
        };

      }
      c = c + 1;
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  }

  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }



  toggleHiddenDiv1() {
    this.showHiddenDiv1 = !this.showHiddenDiv1;
  }

  updateTab(tab: number) {
    this.currentTab = tab;
  }



  useramount() {
    this.showSpinner = true;
    this.admin_id = this.route.snapshot.queryParams.user_id;
    if (this.admin_id) {
      const id = parseInt(this.admin_id);
      this.accountsServices.getadmindatadetail(id).then((value) => {
        this.showSpinner = false;
        this.user_Amount = value.data.user_account_data;
        this.currentPage = 1;
        this.originalData = this.user_Amount?.slice();
      });
    } else {
      this.accountsServices.getamountdetail().then((value) => {
        this.showSpinner = false;
        this.user_Amount = value.data.user_account_data;
        this.currentPage = 1;
        this.originalData = this.user_Amount?.slice();
      });
    }
  }

  get paginatedData() {

    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.user_Amount?.slice(startIndex, startIndex + this.itemsPerPage);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  get totalPages() {
    return Math.ceil(this.user_Amount?.length / this.itemsPerPage);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }


  chartvalue() {
    this.showSpinner = true;
    const id = this.user.id
    this.accountsServices.getchartdetail(id).then((value) => {

      this.showSpinner = false;

      if (!this.admin_id) {
        const available = value.data.available
        const birthday = value.data.birthday
        const event = value.data.event
        const misaliance = value.data.misaliance
        const pattycash = value.data.pattycash
        const reserve = value.data.reserve
        const sport = value.data.sport
        const utilities = value.data.utilities
        const stationary = value.data.stationary
        const office_expense = value.data.office_expense
        const groceries = value.data.groceries
        const internet = value.data.internet
        const office_items = value.data.office_items
        const travel = value.data.travel
        const fun_entertainment = value.data.fun_entertainment
        const emergency = value.data.emergency
        const technology = value.data.technology
        const food = value.data.food
        const healh_inssurance = value.data.healh_inssurance
        const others = value.data.others
        this.graphdataArray = [
          // { asset: "Total Available", amount:parseInt(this.total_Amount) },
          { asset: "Available", amount: available },
          { asset: "Birthday", amount: birthday },
          { asset: "Event", amount: event },
          { asset: "Misaliance", amount: misaliance },
          { asset: "Pattycash", amount: pattycash },
          { asset: "Reserve", amount: reserve },
          { asset: "Sport", amount: sport },
          { asset: "Utilities", amount: utilities },
          { asset: "Stationary", amount: stationary },
          { asset: "Office Expense", amount: office_expense },
          { asset: "Groceries", amount: groceries },
          { asset: "Internet", amount: internet },
          { asset: "Office_items", amount: office_items },
          { asset: "Travel", amount: travel },
          { asset: "Fun Entertainment", amount: fun_entertainment },
          { asset: "Emergency", amount: emergency },
          { asset: "Technology", amount: technology },
          { asset: "Food", amount: food },
          { asset: "Healh Inssurance", amount: healh_inssurance },
          { asset: "Others", amount: others },

        ]


        this.options = {
          series: [
            {
              data: this.graphdataArray,
              type: 'pie',
              angleKey: 'amount',
              calloutLabelKey: 'asset',
              sectorLabelKey: 'amount',
              sectorLabel: {
                color: 'white',
                fontWeight: "bold",
                formatter: ({ value }) => `${(value / 1000).toFixed(1)}K/-`,
              },
              calloutLabel: {
                color: 'white',

                // fontWeight: 'bold'
              },

            },
          ],

          legend: {
            enabled: false,
          },


          background: {
            fill: 'transparent'
          },
        };
      }

    }
    )
  }




  totalamount() {
    this.showSpinner = true;
    const id = this.user.id
    if (this.admin_id) {
      const id = parseInt(this.admin_id);
      this.accountsServices.getadminamountdetail(id).then((value) => {
        this.showSpinner = false;
        this.total_Amount = value.data.available_amount
        this.expense = value.data?.expense_amount
        this.reserve = value.data?.reserve_amount
        this.deposit = value.data?.total_deposit
        this.graphdataArray = [
          // { asset: "Total Available", amount:parseInt(this.total_Amount) },
          { asset: "Amount", amount: parseInt(this.total_Amount) },
          { asset: "Expese", amount: parseInt(this.expense) },
          { asset: "Reserve", amount: parseInt(this.reserve) },
          { asset: "Deposit", amount: parseInt(this.deposit) },
        ]


        this.options = {
          series: [
            {
              data: this.graphdataArray,
              type: 'pie',
              angleKey: 'amount',
              calloutLabelKey: 'asset',
              sectorLabelKey: 'amount',
              sectorLabel: {
                color: 'white',
                fontWeight: "bold",
                formatter: ({ value }) => `RS:${(value / 1000).toFixed(0)}K/-`,
              },
              calloutLabel: {
                color: 'white',

                // fontWeight: 'bold'
              },

            },
          ],

          legend: {
            enabled: false,
          },


          background: {
            fill: 'transparent'
          },
        };



      });
    } else {
      this.accountsServices.getuseramountdetail(id).then((value) => {
        this.showSpinner = false;

        this.total_Amount = value.data.available_amount
        this.expense = value.data?.expense_amount
        this.reserve = value.data?.reserve_amount
        this.deposit = value.data?.total_deposit

      });
    }
  }


  // edit accounts
  editaccount(data: any) {
    this.modalData = data;
    const modalElement: any = this.addExpenseModal.nativeElement;
    $(modalElement).modal('show');
    if (data && data.account_type === 'credit') {
      this.currentTab = 1;
    } else {
      this.currentTab = 2;
    }
    this.editeamount = this.modalData?.amount
    this.account_id = this.modalData?.id
    this.editedate = this.modalData?.date
    this.editedescription = this.modalData?.description
    this.editeexpense_type = this.modalData?.expense_type
  }

  onSubmit(form: NgForm) {
    if (this.account_id) {
      this.form_data = form.value;
      const formData = form.value;
      const ammount_type = this.currentTab;
      if (ammount_type == 1) {
        this.account_type = "credit";
      } else if (ammount_type == 2) {
        this.account_type = "debit";

      }
      this.accountsServices.editeacount(formData, this.account_id, this.account_type).then((value) => {

        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
        else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }

      })
    }
    else {

      this.form_data = form.value;
      const formData = form.value;
      const ammount_type = this.currentTab;
      if (ammount_type == 1) {
        this.account_type = "credit";
      } else if (ammount_type == 2) {
        this.account_type = "debit";

      }
      this.accountsServices.addamount(formData, this.account_type).then((value) => {
        if (value.success == true) {

          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });
          window.location.reload()
        } else {
          const totalAmountString = this.total_Amount;
          const totalAmountNumber = parseInt(totalAmountString);
          const total_remaining = parseInt(this.reserve) + totalAmountNumber
          if (form.value.total_amount > totalAmountNumber && form.value.total_amount <= total_remaining) {
            this.openErrorModal();
          }
          else if (form.value.total_amount > totalAmountNumber && form.value.total_amount > total_remaining) {
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
              title: value.message,
              showConfirmButton: false,
              timer: 1500,
            });
            window.location.reload()
          }
        }
      })
    }



  }
  reserveamount() {

    this.form_data

    this.accountsServices.reservecal(this.form_data, this.account_type).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
    })
  }


  openErrorModal() {
    // Close the first modal
    if (this.addExpenseModal) {
      const addExpenseModal: any = this.addExpenseModal.nativeElement;
      $(addExpenseModal).modal('hide');
    }

    // Open the second modal
    if (this.errorModal) {
      const errorModal: any = this.errorModal.nativeElement;
      $(errorModal).modal('show');
    }
  }

  closeErrorModal() {
    if (this.errorModal) {
      const errorModal: any = this.errorModal.nativeElement;
      $(errorModal).modal('hide');
    }
  }


  getExpenseColor(expenseType: string): string {
    switch (expenseType) {
      case 'events':
        return '#FFF7F1';
      case 'sports':
        return '#E9EDD0';
      case 'misalliance':
        return '#EEE5EF';
      case 'birthday':
        return '#D0F1D8';
      case 'patty_cash':
        return '#E6EDF1';
      case 'available':
        return '#D1F5D3';
      case 'reserve':
        return '#C6F8DE';
      default:
        return 'white';
    }
  }
  getColor(expenseType: string): string {
    switch (expenseType) {
      case 'events':
        return '#FFB600';
      case 'sports':
        return '#FF4454';
      case 'misalliance':
        return '#4F6DD6';
      case 'birthday':
        return '#006DA0';
      case 'patty_cash':
        return '#00BFE6';
      case 'available':
        return '#0D936B';
      case 'reserve':
        return '#00D1DC';
      default:
        return 'red';
    }
  }

  selectFunction() {
    switch (this.selectedOption) {
      case 'reserve':
        this.filterreserve();
        break;
      case 'events':
        this.filterevents();
        break;
      case 'sports':
        this.filtersports();
        break;
      case 'birthday':
        this.filterbirthday();
        break;
      case 'patty_cash':
        this.filterpatty_cash();
        break;
      case 'misalliance':
        this.filtermisalliance();
        break;
      case 'available':
        this.filteravailable();
        break;
      case 'all':
        this.filterall();
        break;

      default:
        break;
    }
  }
  filterreserve() {

    this.user_Amount = this.originalData.filter(item => item.expense_type === 'reserve');

  }
  filterevents() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'events')
  }
  filtersports() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'sports')
  }
  filterbirthday() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'birthday')
  }
  filterpatty_cash() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'patty_cash')
  }
  filtermisalliance() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'misalliance')
  }
  filteravailable() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'available')
  }
  filterall() {
    this.user_Amount = this.originalData
  }


  selectexpense_typ() {
    switch (this.selectedOption) {
      case 'debit':
        this.filterdebit();
        break;
      case 'credit':
        this.filtcredit();
        break;
      case 'both':
        this.filtboth();
        break
      default:
        break;
    }
  }

  filterdebit() {
    this.user_Amount = this.originalData.filter(item => item.account_type === 'debit');
  }

  filtcredit() {
    this.user_Amount = this.originalData.filter(item => item.account_type === 'credit');
  }
  filtboth() {
    this.user_Amount = this.originalData;
  }



  delete_account(data: any) {
    const a = data
    this.id = a.id
  }
  deleteaccount() {
    const account_id = this.id
    this.accountsServices.deleteacount(account_id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
    })

  }


  applyfilter() {
    this.startDate
    this.endDate
    this.accountsServices.getamountfilter(this.startDate, this.endDate).then((value) => {
      this.showSpinner = false;
      this.filtedata = value.data;
      // Export filtered data after fetching
      if (this.filtedata.length != 0) {
        this.user_Amount = this.filtedata

      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: 'No data is Found',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
    });

  }


  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);

    switch (type) {
      case "view":
        return user_role.account_data.data.values.view ?? false
      case "add":
        return user_role.account_data.data.values.add ?? false
      case "export":
        return user_role.account_data.data.values.export ?? false
      case "delete":
        return user_role.account_data.data.values.delete ?? false
      case "edit":
        return user_role.account_data.data.values.edit ?? false
      default:
        return false;


    }
    return false
  }




}
